import { createContext, type ReactNode, useContext } from 'react';

const NestedPlaceholderContext = createContext<boolean>(false);

interface Props {
	children: ReactNode;
}

export function NestedPlaceholderContextProvider({ children }: Props) {
	return (
		// Explicit for clarity in this case.
		// oxlint-disable-next-line react/jsx-boolean-value
		<NestedPlaceholderContext value={true}>{children}</NestedPlaceholderContext>
	);
}
NestedPlaceholderContextProvider.displayName =
	'NestedPlaceholderContextProvider';

export function useIsInNestedPlaceholder() {
	return useContext(NestedPlaceholderContext);
}
